import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock } from "lucide-react";
import api from "@/lib/api";
import { Pic } from "@/components/reading/ReadingExercise";

// Shelf of Kiko stories on the reading path: locked until the lesson in the story's "after" is mastered.
export default function StoryShelf() {
  const { childId, lang } = useParams();
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  useEffect(() => { api.get(`/reading/${childId}/stories/${lang}`).then(({ data }) => setList(data.stories)).catch(() => {}); }, [childId, lang]);
  if (!list.length) return null;
  const fr = lang === "fr";
  return (
    <section className="mb-10" data-testid="story-shelf">
      <h2 className="text-2xl font-bold mb-4">📚 {fr ? "Les histoires de Kiko" : "Kiko's stories"}</h2>
      <div className="grid grid-cols-3 gap-4">
        {list.map((s, k) => (
          <motion.button key={s.id} whileHover={s.unlocked ? { y: -4, rotate: -1 } : {}} whileTap={{ scale: 0.95 }} disabled={!s.unlocked}
            initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: k * 0.1 }}
            onClick={() => navigate(`/kid/${childId}/reading/story/${s.id}`)} data-testid={`story-cover-${s.id}`}
            className={`relative rounded-3xl border-[3px] border-slate-900 bg-white p-3 shadow-[5px_5px_0_0_#0F172A] flex flex-col items-center gap-2 ${s.unlocked ? "" : "opacity-60"}`}>
            <Pic k={s.cover} label="📖" className={`w-full aspect-square ${s.unlocked ? "" : "grayscale blur-[2px]"}`} />
            <p className="font-bold text-sm sm:text-base text-center leading-tight">{s.title}</p>
            {!s.unlocked && (
              <span className="absolute inset-0 flex flex-col items-center justify-center gap-1 text-center px-2">
                <Lock size={30} className="bg-white rounded-full p-1.5 border-2 border-slate-900 box-content" />
                <span className="text-xs font-bold bg-white rounded-full px-2 py-0.5 border-2 border-slate-900">{fr ? `Après : ${s.after}` : `After: ${s.after}`}</span>
              </span>
            )}
          </motion.button>
        ))}
      </div>
    </section>
  );
}
